import {
  confirmAccountDeletionRequest,
  createTipCheckoutRequest,
  createTipCheckoutResponse,
  getMinVersionRequest,
  getMinVersionResponse,
  requestAccountDeletionRequest,
  signOutRequest,
} from "./account.dto";
import { apiV2 } from "./v2";

export const createTipCheckoutApi = apiV2("POST", "/tips/checkout").withRequest(createTipCheckoutRequest).withResponse(createTipCheckoutResponse);

/** Emails the signed-in user a confirmation link. */
export const requestAccountDeletionApi = apiV2("DELETE", "/me/account").withRequest(requestAccountDeletionRequest);

/** Anonymous: the token from the emailed link is the credential. */
export const confirmAccountDeletionApi = apiV2("POST", "/auth/confirm-account-deletion").withRequest(confirmAccountDeletionRequest);

export const signOutApi = apiV2("POST", "/auth/signout").withRequest(signOutRequest);

export const getMinVersionApi = apiV2("GET", "/app/min-version").withRequest(getMinVersionRequest).withResponse(getMinVersionResponse);
